document.addEventListener('DOMContentLoaded', function () {
    this.cartUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        (event) => {
            recoverValues();
            updateCustomizationFields();
            setListeners();
        },
    );

    setListeners();

    function setListeners() {
        const allFields = document.querySelectorAll('.item_customization_field');
        allFields.forEach(function (field) {
            field.addEventListener('input', updateCustomizationFields);
        });
    }

    function updateCustomizationFields() {
        const customizationAttributeFields = document.querySelectorAll('.item_customization_attribute');

        customizationAttributeFields.forEach(function (attrField) {
            const propertyName = attrField.getAttribute('data-customization-property');
            const propertyFields = document.querySelectorAll('.item_customization_field.property_' + propertyName);
            const propertyValue = Array.from(propertyFields).map(function (propField) {
                return propField.value.trim();
            }).filter(function (value) {
                return value.length > 0;
            }).join(',');
            attrField.value = propertyValue;
        });
    }

    function recoverValues() {
        const customizationAttributeFields = document.querySelectorAll('.item_customization_attribute');

        customizationAttributeFields.forEach(function (attrField) {
            const propertyName = attrField.getAttribute('data-customization-property');
            const propertyFields = document.querySelectorAll('.item_customization_field.property_' + propertyName);

            const propertyValues = attrField.value.split(',');
            propertyFields.forEach(function (propertyField, i) {
                if (propertyValues.length > i) {
                    propertyField.value = propertyValues[i];
                }
            });
        });
    }
});